import axios, { AxiosRequestConfig, AxiosResponse as IAxiosResponse } from 'axios';
import { getAuthToken } from './get-auth-token';

export async function appendAuthToken(config?: AxiosRequestConfig): Promise<AxiosRequestConfig> {
	// use `=== false` explicitly in order to catch empty configs {}
	if (config && config.withCredentials === false) {
		return config;
	}

	config = { ...config, withCredentials: true };

	const token = await getAuthToken();
	config.headers = config.headers || {};
	config.headers.Authorization = `Bearer ${token}`;

	return config;
}

// tslint:disable-next-line
export interface AxiosResponse<T = any> extends IAxiosResponse<T> {}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	get: async <T = any>(url: string, config?: AxiosRequestConfig) => axios.get<T>(url, await appendAuthToken(config)),
	post: async <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
		axios.post<T>(url, data, await appendAuthToken(config)),
	put: async <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
		axios.put<T>(url, data, await appendAuthToken(config)),
	patch: async <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
		axios.patch<T>(url, data, await appendAuthToken(config)),
	delete: async (url: string, config?: AxiosRequestConfig) => axios.delete(url, await appendAuthToken(config)),
};
